module.exports = __webpack_public_path__ + "902815b46c3d25debb160557f39996b5.png";